import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FinalCTA: React.FC = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 bg-brand-blue rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-brand-red rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-10">
          <h2 className="text-4xl md:text-6xl font-black text-brand-navy leading-tight">
            Ready for a <span className="text-brand-blue">Cleaner Home</span>?
          </h2>
          
          <p className="text-xl text-brand-navy/70 max-w-2xl mx-auto leading-relaxed">
            Join hundreds of happy homeowners in Jersey City and Hoboken. 
            Book your professional cleaning service today and experience the difference.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link
              to="/contact"
              className="w-full sm:w-auto bg-brand-red text-white px-12 py-5 rounded-2xl font-black text-xl shadow-2xl hover:bg-red-700 transition-all transform hover:scale-105 flex items-center justify-center space-x-3"
            >
              <span>Get My Free Quote</span>
              <ArrowRight className="w-6 h-6" />
            </Link>
            
            <div className="flex flex-col items-center sm:items-start">
              <p className="text-xs font-bold text-brand-navy/40 uppercase tracking-widest mb-1">Or call us directly</p>
              <a href="tel:2018700452" className="text-2xl font-black text-brand-navy hover:text-brand-blue transition-colors">
                (201) 870-0452
              </a>
            </div>
          </div>
          
          <div className="pt-12 flex flex-wrap justify-center gap-8 opacity-50 grayscale">
            <img src="/assets/img/logo.png" alt="CleanHouse NJ" className="h-8 w-auto" />
            <div className="h-8 w-px bg-brand-navy/20"></div>
            <p className="text-sm font-bold text-brand-navy uppercase tracking-widest">American Owned & Operated</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
